import React, { useState, useEffect } from 'react';
import stringSimilarity from 'string-similarity';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Holdings from './Holdings';
import Info from './Info';
import Statistics from './Statistics';
import TotalOverlap from './TotalOverlap';

const Overlap = ({ etfData }) => {
    const [etfOverlap, setEtfOverlap] = useState([]);
    const [stats, setStats] = useState([
        { value: '0', label: 'Number of overlapping holdings' },
        { value: '0', label: '% of \'s holdings also in' },
        { value: '0', label: '% of \'s holdings also in' },
    ]);
    const [etfInfo, setEtfInfo] = useState([]);
    const [totalOverlap, setTotalOverlap] = useState(0);

    useEffect(() => {

        const getOverlap = (etf1, etf2, limit = 100) => {
            const etf1Holdings = etf1.Holdings.slice(0, limit);
            const etf2Holdings = etf2.Holdings.slice(0, limit);
            const overlap = [];
            var totalOverlap = 0;
            var overlapWeight = 0;
            for (let i = 0; i < etf1Holdings.length; i++) {
                for (let j = 0; j < etf2Holdings.length; j++) {
                    const etf1Holding = etf1Holdings[i];
                    const etf2Holding = etf2Holdings[j];
                    if (compareStock(etf1Holding, etf2Holding)) {
                        overlapWeight = Math.min(etf1Holding['Weight (%)'].toFixed(1),
                            etf2Holding['Weight (%)'].toFixed(1));
                        overlap.push({
                            Name: etf1Holding['Name'].toUpperCase(),
                            Weight1: etf1Holding['Weight (%)'].toFixed(1),
                            Weight2: etf2Holding['Weight (%)'].toFixed(1),
                            OverlapWeight: overlapWeight.toFixed(1),
                            Location:
                                etf1Holding['Location'] || etf2Holding['Location'],
                            Sector:
                                [etf1Holding['Sector'], etf2Holding['Sector']],
                        });
                        totalOverlap += overlapWeight;
                        break;
                    }
                }
            }
            setEtfOverlap(overlap);
            setStats([
                {
                    value: `${overlap.length}`,
                    label: 'Number of overlapping holdings'
                },
                {
                    value: `${((overlap.length / etf1Holdings.length) * 100).toFixed(1)}%`,
                    label: `of ${etf1.Ticker}'s holdings also in ${etf2.Ticker}'s top ${etf1Holdings.length} holdings`
                },
                {
                    value: `${((overlap.length / etf2Holdings.length) * 100).toFixed(1)}%`,
                    label: `of ${etf2.Ticker}'s holdings also in ${etf1.Ticker}'s top ${etf2Holdings.length} holdings`
                },
            ]);
            setEtfInfo([etf1, etf2]);
            setTotalOverlap(totalOverlap.toFixed(1));
        }

        console.log(etfData);
        if (etfData['etf1'] && etfData['etf2']) {
            if (Object.keys(etfData['etf1']).length !== 0 && Object.keys(etfData['etf2']).length !== 0) {
                getOverlap(etfData['etf1'], etfData['etf2']);
            }
        }
    }, [etfData]);

    const compareStock = (stock1, stock2) => {
        if (stock1.Ticker && stock2.Ticker) {
            return stock1.Ticker === stock2.Ticker;
        } else {
            const name1 = stock1.Name.toLowerCase();
            const name2 = stock2.Name.toLowerCase();
            var similarity = stringSimilarity.compareTwoStrings(
                stock1.Name.toLowerCase(), stock2.Name.toLowerCase());
            if (similarity > 0.8) {
                const regex = /.*class (\w)/;
                const match1 = name1.match(regex);
                const match2 = name2.match(regex);
                if (match1 && match2) {
                    return match1[1] === match2[1];
                }
                return true;
            } else {
                return false;
            }
        }
    }

    return (
        <Grid container direction="column" rowSpacing={2}>
            <Grid container item>
                <Info info={etfInfo} />
            </Grid>
            <Grid item>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>At a Glance</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TotalOverlap totalOverlap={totalOverlap} info={etfInfo} />
                        <Statistics stats={stats} />
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                    >
                        <Typography>Holding Details</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Holdings rows={etfOverlap} info={etfInfo} />
                    </AccordionDetails>
                </Accordion>
            </Grid>
        </Grid>
    );
}

export default Overlap;